import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FacilitiesPayorComponent } from './facilities-payor.component';
import {AutoCompleteFacilitiesModule} from '../auto-complete-facilities/auto-complete-facilities.module';
import {AgGridModule} from 'ag-grid-angular';
import {FacilitiesPayorService} from './facilities-payor.service';

@NgModule({
  imports: [
    CommonModule,
    AutoCompleteFacilitiesModule,
    AgGridModule.withComponents([])
  ],
  declarations: [
    FacilitiesPayorComponent
  ],
  exports: [
    FacilitiesPayorComponent
  ],
  providers: [
    FacilitiesPayorService
  ]
})
export class FacilitiesPayorModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/facilities-payor/facilties-payor.module.ts